<nz-progress [nzPercent]="value" nzStatus="active"></nz-progress>